import { render, staticRenderFns } from "./therm-v2-defect-details-popup.vue?vue&type=template&id=6f715c76"
import script from "./therm-v2-defect-details-popup.vue?vue&type=script&lang=js"
export * from "./therm-v2-defect-details-popup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports